import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent, InfoDialogContentComponent } from '@iw/common';

@Component({
  selector: 'iw-vpn-check-dialog',
  styleUrl: './vpn-check-dialog.component.scss',
  templateUrl: './vpn-check-dialog.component.html',
  imports: [
    IconModule,
    ButtonComponent,
    TranslateModule,
    InfoDialogContentComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VpnCheckDialogComponent {
  readonly #dialogRef = inject(DialogRef);

  close() {
    this.#dialogRef.close();
  }
}
